import { Tooltip } from "antd";
import * as React from "react";
import { getWorkflowStepDisplayName } from "src/business/workflow/getWorkflowStepDisplayName";
import { isInitialStep } from "src/business/workflow/workflowSteps";
import { ZWorkflowStep } from "src/business/workflow/ZWorkflowStep";

type PropsPrevStepsCell = {
  curStep: ZWorkflowStep;
  allSteps: ZWorkflowStep[];
};

export const PrevStepsCell: React.FC<PropsPrevStepsCell> = ({
  curStep,
  allSteps,
}) => {
  // У Initial предшественников не бывает
  if (isInitialStep(curStep)) return "-";
  const predecessors = curStep?.predecessors ?? [];
  if (!predecessors?.length) return predecessors?.length ?? "";

  const title = (
    <div>
      {predecessors.map(({ id }) => (
        <div key={id}>
          {getWorkflowStepDisplayName(allSteps.find((step) => step.id === id))}
        </div>
      ))}
    </div>
  );
  return <Tooltip title={title}>{predecessors.length}</Tooltip>;
};
